import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.join";
import "core-js/modules/es.function.name";
import { __values } from "tslib";

var Gift =
/** @class */
function () {
  function Gift(gift) {
    // this.choices = gift.choices;
    this.choices = gift.choices.filter(function (ele) {
      var _a;

      return (((_a = ele.left_count) !== null && _a !== void 0 ? _a : 999) || (ele.left_count === 0 && ele.id === gift.specification ? 1 : 0)) > 0;
    });
    this.choices_o = gift.choices;
    this.price = gift.price;
    this.id = gift.id;
    this.name = gift.name;
    this.size_table = gift.size_table;
    this.spec_1 = gift.spec_1;
    this.spec_2 = gift.spec_2;
    this.spec_3 = gift.spec_3;
    this.specification = gift.specification;
    this.confirm_word = gift.confirm_word;
    this.can_change_before = gift.can_change_before;
    this.change_spec_days = gift.change_spec_days;
    this.can_change = gift.can_change;
    this.spec_map = gift.spec_map;
    this.image = gift.image;
    this.type = gift.type;
    this.order_id = gift.order_id;
  }

  Gift.prototype.getSpec = function () {
    var e_1, _a, e_2, _b;

    if (!this.specification) {
      return '';
    }

    try {
      for (var _c = __values(this.choices), _d = _c.next(); !_d.done; _d = _c.next()) {
        var choice = _d.value;

        if (choice.id === this.specification) {
          return [this.spec_1 ? this.spec_1 + ':' : null, choice.spec_1, this.spec_2 ? this.spec_2 + ':' : null, choice.spec_2, this.spec_3 ? this.spec_3 + ':' : null, choice.spec_3].filter(function (_) {
            return _;
          }).join(' ');
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c["return"])) _a.call(_c);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    try {
      for (var _e = __values(this.choices_o), _f = _e.next(); !_f.done; _f = _e.next()) {
        var choice = _f.value;

        if (choice.id === this.specification) {
          return [this.spec_1 ? this.spec_1 + ':' : null, choice.spec_1, this.spec_2 ? this.spec_2 + ':' : null, choice.spec_2, this.spec_3 ? this.spec_3 + ':' : null, choice.spec_3].filter(function (_) {
            return _;
          }).join(' ');
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_f && !_f.done && (_b = _e["return"])) _b.call(_e);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return '';
  };

  return Gift;
}();

export default Gift;